export default __webpack_public_path__ + "static/rabies-1dd4999dc48fe1eae51b21a10193484c.png";